import { useQuery } from "@tanstack/react-query";
import { toggleContentBlockerTemplateFavourite } from "../../api/real-cookie-banner.js";
import { useStores } from "../../store/root.js";
import { QueryKeys } from "../../util/query-keys.js";
/**
 * Toggle favourite state of given ContentBlockerTemplate via RCB ContentBlocker API.
 */ function useToggleContentBlockerTemplateFavourite(id) {
    const { rcbAuthenticationStore } = useStores();
    return useQuery(QueryKeys.toggleFavouriteContentBlocker(id), ({ signal })=>toggleContentBlockerTemplateFavourite({
            signal,
            language: "en",
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                id: String(id)
            }
        }), {
        staleTime: Infinity,
        retry: false,
        enabled: String(id)?.trim().length > 0 && !isNaN(Number(id))
    });
}
export { useToggleContentBlockerTemplateFavourite };
